module.exports = __webpack_public_path__ + "assets/rejs.e367565dca7b2870bee301143e3af7a5.png";